import script from "./CookiePolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&setup=true&lang=js"

import "./CookiePolicy.vue?vue&type=style&index=0&id=22483493&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22483493"]])

export default __exports__